import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import KRUpdateModal from './kr-data';
import UpdateKRPopupReducer from '../../../reducers/updateKRPopup.reducers';

const openKRUpdateModal = (data: any) => {
    const updateKRStore = createStore(UpdateKRPopupReducer, data, applyMiddleware(thunkMiddleware));
    ReactDOM.render(
        <Provider store={updateKRStore}>
            <KRUpdateModal
                {...data}
            />
        </Provider>,
        document.getElementById('editMetricData'),
    );
}
(window as any).openKRUpdateModal = openKRUpdateModal;
